module.exports = __webpack_public_path__ + "img/portraits_29_V.392a683f.webp";